import React, { FC } from 'react';
import GoogleLogin from 'react-google-login';
import Styled from './style';
import useHook from './hook';
import salesforce from '../../assets/images/salesforce-text.png';
import google from '../../assets/images/google.png';
import { AuthWrapper } from '../../shared/auth-wrapper';
import MUIButton from '../../shared/mui-button';

type IProps = {
	location: any;
};

const LoginPage: FC<IProps> = ({ location }) => {
	const { salesforceLogin, handleLogin, handleLoginWithInvitation } =
		useHook();
	// const { isSalesLoading, isGoogleLoading } = state;
	const token = new URLSearchParams(location.search).get('token');
	const refreshToken = new URLSearchParams(location.search).get('refreshToken');
	refreshToken && localStorage.setItem('refresh_token', refreshToken);

	return (
		<AuthWrapper>
			<Styled.Bottom>
				<Styled.WrapTitle>
					<Styled.Title
						text={'Log in to your team space'}
						style={{ textAlign: 'center' }}
					/>
				</Styled.WrapTitle>
				<Styled.Content>
					<div style={{ width: '100%' }}>
						<Styled.ButtonWrapper>
							<MUIButton
								title="Sign up with"
								size="large"
								imageLeft={false}
								callBack={salesforceLogin}
								image={
									<img
										src={salesforce}
										style={{ height: 30, marginTop: 2 }}
										alt=""
									/>
								}
							/>
						</Styled.ButtonWrapper>
						<Styled.Separator>
							<Styled.Line />
							<Styled.SeparatorText
								type="title"
								size={'normal'}
								color={'btnTextGrey'}
								text="OR"
							/>
							<Styled.Line />
						</Styled.Separator>
						<Styled.ButtonWrapper>
							<GoogleLogin
								clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID as string}
								onSuccess={googleData => {
									handleLogin(googleData);
									handleLoginWithInvitation(googleData, token);
								}}
								cookiePolicy={'single_host_origin'}
								render={renderProps => (
									<MUIButton
										title="Sign up with Google"
										size="large"
										color="black"
										variant="outlined"
										callBack={renderProps.onClick}
										backgroundColor="none"
										image={
											<img
												src={google}
												style={{ height: 22, marginRight: 10 }}
												alt=""
											/>
										}
									/>
								)}
							/>
						</Styled.ButtonWrapper>
					</div>
				</Styled.Content>
			</Styled.Bottom>
		</AuthWrapper>
	);
};

export default LoginPage;
